import React from "react";
import CardMedia from "@mui/material/CardMedia";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvButton from "@directv-digital/dds.ui.dtv-button";
import { IChnlInteractiveThemeUI } from "lib/helper/channel-interactive-tool-theme";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import { showMoreButtonContainerStyles, getShowMoreButtonStyles, showMoreArrowIconStyles } from "./styles";

interface ShowMoreButtonProps {
  categoryKey: string;
  categoryIndex: number;
  isExpanded: boolean;
  theme?: IChnlInteractiveThemeUI;
  onToggle: (categoryKey: string) => void;
  onLoad?: (element: HTMLElement | null) => void;
}

const ShowMoreButton: React.FC<ShowMoreButtonProps> = ({ categoryKey, categoryIndex, isExpanded, theme, onToggle, onLoad }) => {
  try {
    const handleClick = (evt: React.MouseEvent<HTMLButtonElement>) => {
      evt.currentTarget.blur();
      onToggle(categoryKey);
    };

    return (
      <DtvBox id={`chnlCtg-show-more-${categoryIndex}`} sx={showMoreButtonContainerStyles}>
        <DtvButton
          ariaLabel={isExpanded ? "Show Less channels" : "Show More channels"}
          label={isExpanded ? "Show Less" : "Show More"}
          sx={getShowMoreButtonStyles(theme)}
          variant="uxtext"
          endIcon={
            <CardMedia
              alt={isExpanded ? "Click to show less" : "Click to show more"}
              component="img"
              loading="lazy"
              src="https://www.directv.com/dtvassets/global/icons/2022/arrow_down_gray700.svg"
              sx={showMoreArrowIconStyles(isExpanded)}
            />
          }
          onClick={handleClick}
          onLoad={() => {
            if (onLoad) {
              const iconCtnr = document.getElementById(`chnlCtg-icons-${categoryKey}`);
              onLoad(iconCtnr);
            }
          }}
        />
      </DtvBox>
    );
  } catch (error) {
    console.error("Error in ShowMoreButton >> ", error);
    return <ErrorDisplay component="Show More Button" error={error} />;
  }
};

export default React.memo(ShowMoreButton);
